var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.activityStream.activities && _vm.loading !== 0)?_c('loading-spinner'):_c('activity-stream',{attrs:{"activity-stream":_vm.activityStream},on:{"loadMore":_vm.loadMore}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }